import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CentroCustosComponent } from './centro-custos.component';
import { ListCentroCustosComponent } from '../components/list-centro-custos/list-centro-custos.component';
import { CentroCustosRoutingngModule } from './centro-custos.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';

const components = [
  CentroCustosComponent,
  ListCentroCustosComponent,
]

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    CentroCustosRoutingngModule
  ],
  declarations: [...components]
})
export class CentroCustosModule { }
